module.exports = __webpack_public_path__ + "de421950ef2f9a8ffd85dd1f9e5601fc.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/orks-vignette-preview-420.webp.png
// module id = 494
// module chunks = 0